import { render, staticRenderFns } from "./order.vue?vue&type=template&id=1ac60144&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=1ac60144&prod&scoped=true&lang=css&"
import style1 from "./order.vue?vue&type=style&index=1&id=1ac60144&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac60144",
  null
  
)

export default component.exports